export const pageConstant = {
  PAGE_REQUEST: "PAGE_REQUEST",
  PAGE_SUCCESS: "PAGE_SUCCESS",
  PAGE_FAILURE: "PAGE_FAILURE",

  ABOUTCHOOSE_DATA_REQUEST: "ABOUTCHOOSE_DATA_REQUEST",
  ABOUTCHOOSE_DATA_SUCCESS: "ABOUTCHOOSE_DATA_SUCCESS",
  ABOUTCHOOSE_DATA_FAILURE: "ABOUTCHOOSE_DATA_FAILURE",
};
